/*@ngInject*/
export default ['$resource','BASE_URL', function ($resource, BASE_URL){ return $resource(BASE_URL + "/inbound/configuration/numbers/:id/:action", {}, {
    getProjects: {method: 'GET', isArray: true, params: {id: '@id', action: 'projects'}},
    getNumberSettings: {method: 'GET',  params: {id: '@id'}},
    setNumberSettings: {method: 'POST',  params: {id: '@id'}},
})}];
